const getDefaultState = () => {
    return {
        scopesEnabled: false,
        activeScopeType: {
            text: "RGB Parade",
            value: "parade",
        },
        scopeTypes: [
            {
                text: "RGB Parade",
                value: "parade",
            },
            {
                text: "Waveform",
                value: "waveform",
            },
            {
                text: "Vectorscope",
                value: "vectorscope",
            },
            {
                text: "Histogram",
                value: "histogram",
            },
        ],

        activeHistogramType: {
            text: "RGB",
            value: "rgb",
        },

        histogramTypes: [
            {
                text: "RGB",
                value: "rgb",
            },
            {
                text: "Red",
                value: "red",
            },
            {
                text: "Green",
                value: "green",
            },
            {
                text: "Blue",
                value: "blue",
            },
            {
                text: "Hue",
                value: "hue",
            },
            {
                text: "Saturation",
                value: "sat",
            },
            {
                text: "Brightness",
                value: "val",
            },
        ],
    };
};

const Scopes = {
    namespaced: true,

    state: getDefaultState(),
    mutations: {
        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },
        SET_SCOPES_ENABLED: (state, payload) => {
            state.scopesEnabled = payload;
        },
        SET_ACTIVE_SCOPE_TYPE: (state, payload) => {
            state.activeScopeType = payload;
        },
    },
    actions: {
        resetState: ({commit}) => {
            commit("RESET_STATE");
        },
        setScopesEnabled: ({commit}, payload) => {
            commit("SET_SCOPES_ENABLED", payload);
        },
        setActiveScopeType: ({ commit }, payload) => {
            commit("SET_ACTIVE_SCOPE_TYPE", payload);
        },
    },
    getters: {}
};

export default Scopes;
